import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

export default function Main() {
   return (
      <>
         <Header />
         <div style={{ minHeight: 'calc(100vh - 115px)' }}>
            <Outlet />
         </div>
         <Footer />
      </>
   )
}
